import React, { useEffect, useState } from 'react';
import { Table, message, Popconfirm, Empty, TableProps, Tooltip, Modal, Image } from 'components/shared/AntComponent';
import { Input, Button } from 'components/shared/FormComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { EditIcon, SendMailIcon } from 'assets/icons/CustomIcons';
import { DeleteFilled, SearchOutlined, PaperClipOutlined } from 'components/shared/AntIcons';
import dayjs from 'dayjs';
import { getExam, removeExam, sendMailtoAll } from 'services/store/actions/examAction';
import ReconfirmDeleteModal from 'components/pages/modal/ReconfirmDeleteModal';
import DelImg from 'assets/img/del.png';
import MenuDot from 'assets/icons/personal-icons/menu-dot.svg';
import CalendarIcon from 'assets/icons/personal-icons/calendar.svg';
import TimeIcon from 'assets/icons/personal-icons/time.svg';
import UsersIcon from 'assets/icons/personal-icons/users-icon.svg';
import papersIcon from 'assets/icons/personal-icons/file-icon.svg';
interface DataType {
    key: number;
    examcode: number;
    exam_title: string;
    exam_date: any;
    total_marks: string;
    exam_duration: string;
    description: any;
}

const ExamScreen: React.FC = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const { examData, loading, success8, error8, loading13, success13, error13 } = useSelector((state: any) => state.exam);
    const [searchValue, setSearchValue] = useState('');
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const data = !loading ? examData?.ExamslotDetails : [];
    const totalRecords = examData?.DataFinder?.totalrecords || 0;
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success8 : false;
    const [showErrMsg, setShowErrMsg] = useState(false);
    const errMsg = showErrMsg ? error8 : false;
    const [openModal, setOpenModal] = useState(false);
    const avatarColors = ['#48bd97', '#d4b12a', '#4868b1', '#7dc242', '##df8967'];
    const [openDelModal, setOpenDelModal] = useState(false);
    const [examID, setExamID] = useState(0);
    const [showSuccessmsg1, setShowSuccessmsg1] = useState(false);
    const successmsg1 = showSuccessmsg1 ? success13 : false;
    const [showErrormsg1, setShowErrormsg1] = useState(false);
    const errormsg1 = showErrormsg1 ? error13 : false;
    const [openDangerModal, setOpenDangerModal] = useState(false);
    const customLocale = {
        emptyText: <Empty className="p-2" description="No Exam Details Available" />,
    };
    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'Code',
            dataIndex: 'examcode',
            key: 'examcode',
        },
        {
            title: 'Title',
            dataIndex: 'exam_title',
            key: 'exam_title',
            width: 400,
            sorter: true,
        },
        {
            title: 'Exam Date',
            dataIndex: 'exam_date',
            key: 'exam_date',
            render: (_: any, record: any) => {
                const date = record?.exam_date ? dayjs(record?.exam_date) : null;
                return record?.exam_date ? date?.format('MM/DD/YYYY') : "--";
            },
        },
        {
            title: 'Total Marks',
            dataIndex: 'total_marks',
            key: 'total_marks',
            align: 'center',
        },
        {
            title: 'Duration',
            dataIndex: 'exam_duration',
            key: 'exam_duration',
            align: 'center',
        },
        // {
        //     title: 'Candidate',
        //     dataIndex: 'description',
        //     key: 'description',
        //     render: (_, record: any) => {
        //         return (
        //             <div>
        //                 {record?.candidates_list?.map((item: any, i: number) => {
        //                     return (
        //                         <Avatar.Group key={i}>
        //                             <Avatar className="text-capitalize" style={{ backgroundColor: `${avatarColors[i % avatarColors.length]}` }}>
        //                                 <Tooltip title={item.fname + " " + item.lname} className='pointer text-capitalize'> {item.fname[0]}</Tooltip>
        //                             </Avatar>
        //                         </Avatar.Group>
        //                     );
        //                 })}
        //             </div>
        //         );
        //     },
        // },

        {
            title: 'Created on',
            dataIndex: 'created_on',
            key: 'created_on',
            render: (_: any, record: any) => {
                const originalDate = new Date(record?.created_on) || null;
                return data ? dayjs(originalDate).format('MM/DD/YYYY') : "--";
            },
        },
        {
            title: 'Exam Link',
            dataIndex: 'uid',
            key: 'uid',
            render: (_: any, record: any) => {
                const url = window.origin;
                return (
                    <Button className='bg-success rounded' type="primary"
                        // icon={<SendMailIcon size={16} />} 
                        // loading={examID == record.id ? loading13 : false}
                        onClick={() => gotoExamPage(`${url}/guest-login/${record.uid}`)}>
                        Copy link
                        {/* //  onClick={() => { sendEmailtoAll(record); setExamID(record?.id) }}> */}
                        {/* {examID == record.id && loading13 ? "Sending mail" : "Send email"} */}
                    </Button>
                );
            },
            align: 'center',
        },
        // {
        //     title: 'Exam Link',
        //     dataIndex: 'uid',
        //     key: 'uid',
        //     render: (_: any, record: any) => {
        //         const url = window.origin;
        //         return (
        //             <Button className='bg-blue' icon={<SendMailIcon size={16} />} loading={examID == record.id ? loading13 : false} onClick={() => { sendEmailtoAll(record); setExamID(record?.id) }}>
        //                 {examID == record.id && loading13 ? "Sending mail" : "Send email"}
        //             </Button>
        //         );
        //     },
        //     align: 'center',
        // },
        {
            title: 'Action',
            dataIndex: 'tags',
            key: 'id',
            align: 'center',
            render: (_, record: any) => {
                const url = window.origin;
                return (
                    <div className="d-flex w-100 justify-content-center">
                        <div className="pointer my-auto edit-icon" onClick={() => editQuestion(record)}>
                            <EditIcon size={32} />
                        </div>
                        <div className="my-auto delete-icon">
                            <Popconfirm title="Delete Exam" description="Are you sure to delete this exam?" onConfirm={() => { deleteQuestion("False", record.id); setExamID(record.id) }} okText="Yes" cancelText="No">
                                <span className="pb-2 fs-17">
                                    <DeleteFilled className="text-danger pointer" />
                                </span>
                            </Popconfirm>
                        </div>
                        <div className="my-auto ps-2 pointer mail-icon">
                            <Tooltip title="Send email">
                                <span onClick={() => {
                                    setExamID(record.id);
                                    if (record.is_mail_send) {
                                        setOpenDangerModal(true);
                                    } else {
                                        setOpenModal(true);
                                    }
                                    // sendEmailtoAll(record); setExamID(record?.id)
                                }} ><SendMailIcon size={16} /></span>
                            </Tooltip>
                        </div>
                        {/* <Tooltip title="Send email">
                            <div className="my-auto ps-2 pointer">
                                <SendMailIcon size={20} />
                            </div>
                        </Tooltip> */}
                    </div>
                )
            },
        },
    ];

    const sendEmailtoAll = () => {
        const inputJson = {
            "examid": examID || "",
            "slotid": 0,
            "email": "",
            "email_resend_flag": false
        }
        dispatch(sendMailtoAll(inputJson) as any);
        setShowSuccessmsg1(true);
        setShowErrormsg1(true);
    }

    const deleteQuestion = (val: any, id: number) => {
        const inputJson = {
            exam_id: id,
            conform_data: val
        }
        dispatch(removeExam(inputJson) as any);
        setShowSuccessmsg(true);
        setShowErrMsg(true);
    };

    useEffect(() => {
        if (successmsg1) {
            message.success('Mail sent successfully');
            setShowSuccessmsg1(false);
            setOpenModal(false);
            setOpenDangerModal(false);
        }
        if (errormsg1) {
            message.error("Mail couldn't be sent at this moment. Kindly contact administrator");
            setShowErrormsg1(false);
            setOpenModal(false);
            setOpenDangerModal(false);
        }
    }, [successmsg1, errormsg1]);

    useEffect(() => {
        if (successmsg) {
            message.success('Exam Deleted Successfully');
            setPageIndex(1);
            getExamDetails(pageSize, 1, '');
            setShowSuccessmsg(false);
            if (examID !== 0) {
                setOpenDelModal(false);
            }
        }
        if (errMsg) {
            if (error8?.data === "Associated candidates or results found") {
                setOpenDelModal(true);
            } else {
                message.error("Exam couldn't be deleted");
            }
            setShowErrMsg(false);

        }
    }, [successmsg, errMsg]);

    const getExamDetails = (size: number, page: number, search: string) => {
        const inputJson = {
            "InputJson": {
                "examid": 0
            },
            "DataFinder": {
                pagesize: size,
                currentpage: page,
                sortbycolumn: '',
                sortby: 'asc',
                searchdata: search || '',
            }
        };
        dispatch(getExam(inputJson) as any);
    };
    useEffect(() => {
        getExamDetails(pageSize, pageIndex, searchValue);
    }, []);

    const gotoExamPage = (url: any) => {
        navigator.clipboard.writeText(url);
        message.success('url copied successfully');
    };

    const editQuestion = (val: any) => {
        history('/exam/add-exam', {
            state: {
                id: val.id,
                examData: val,
            },
        });
    };
    // Pagination configuration
    const paginationConfig: TableProps<DataType>['pagination'] = {
        position: ['bottomRight'],
        current: pageIndex,
        pageSize: pageSize,
        total: totalRecords,
        onChange: (page: number, pageSize: number) => {
            setPageIndex(page);
            setPageSize(pageSize);
            getExamDetails(pageSize, page, searchValue);
        },
        itemRender: (current: any, type: string, originalElement: any) => {
            if (type === 'prev') {
                return <Button className="prev-btn">Previous</Button>;
            }
            if (type === 'next') {
                return <Button className="next-btn">Next</Button>;
            }
            return originalElement;
        },
    };

    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getExamDetails(pageSize, 1, e.target.value);
        }
    };
    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getExamDetails(pageSize, 1, e.target.value);
        }
    };

    const gotoAddScreen = () => {
        history('/exam/add-exam', {
            state: {
                id: 0,
                examData: null,
            },
        });
    };
    const handleBack = () => {
        setOpenDelModal(false);
        setShowErrMsg(false);
    };
    const handleClose = () => {
        setOpenModal(false);
    }

    const callBackFunc1 = (val2: any) => {
        deleteQuestion(val2, examID);
        setShowErrMsg(false);
    };
    const handleCancel1 = () => {
        setOpenDangerModal(false);
    }
    const resendEmail = () => {
        const inputJson = {
            "examid": examID || "",
            "slotid": 0,
            "email": "",
            "email_resend_flag": true
        }
        dispatch(sendMailtoAll(inputJson) as any);
        setShowSuccessmsg1(true);
        setShowErrormsg1(true);
    }
    const getStatusFromDate = (dateString: string) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // remove time part

    const givenDate = new Date(dateString);
    givenDate.setHours(0, 0, 0, 0);

    if (givenDate.getTime() === today.getTime()) {
        return 'Ongoing';
    } else if (givenDate < today) {
        return 'Completed';
    } else {
        return 'Published';
    }
};
    return (
        <div className="my-3">
            <div className="row mx-0 mt-4 pt-3">
                <div className='col my-auto'>
                    <h5 className="col-md-3 text-start my-auto text-secondary fw-bold">Exam</h5>
                    <p className='mt-2'>Manage and monitor all examinations</p>
                </div>
                <div className="col-md-8 pe-1 d-flex ms-auto">
                    <div className="col-md-4 text-start pe-1 ms-auto text-end">
                        {/* <Input
                            prefix={<SearchOutlined />}
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={(e) => handleSearch(e)}
                            onKeyUp={(e) => resetSearch(e)}
                            placeholder="Search"
                        /> */}
                        <Button type="primary" onClick={gotoAddScreen} className="bg-primary ms-2">
                            Create Exam
                        </Button>
                    </div>
                </div>
            </div>
            <div className='bg-white p-4 rounded mx-2 mb-3'>
                <div className="col-md-4 text-start pe-1 d-flex">
                    <Input
                        prefix={<SearchOutlined />}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onKeyDown={(e) => handleSearch(e)}
                        onKeyUp={(e) => resetSearch(e)}
                        placeholder="Search"
                    />
                </div>
            </div>
            <div className="m-2 custom-table">
                <div className='row gx-3'>
                    {data?.map((item: any) => {
                        return (
                            <div className='col-md-3 py-2 px-2' key={item.id}>
                                <div className='bg-white rounded p-3'>
                                    <div className='d-flex'>
                                        <div className='col'>
                                            <h6 className='fw-bold text-dark'>{item.exam_title}</h6>
                                            <small>Mathematics</small>
                                            <div className={`status-badge px-2 py-1 ${getStatusFromDate(item.exam_date).toLowerCase()} col-md-3 rounded mt-2`}>{getStatusFromDate(item.exam_date)}</div>
                                        </div>
                                        <div className='ms-auto col-auto pointer'><img src={MenuDot} height={25} /></div>
                                    </div>
                                    <div className='d-flex w-100 flex-wrap mt-3'>
                                        <div className='col-md-6'>
                                            <div className='d-flex'><img src={CalendarIcon} height={17}/><p className='ps-1'>{item.exam_date ? dayjs(new Date(item.exam_date)).format('DD-MM-YYYY') : "--"}</p></div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='d-flex'><img src={TimeIcon} height={17}/><p className="ps-1">{item?.exam_duration} min</p></div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='d-flex'><img src={UsersIcon} height={17}/><p className="ps-1">{item?.candidate_list?.length} students</p></div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='d-flex'><img src={papersIcon} height={17}/><p className="ps-1">{item?.questionpaper_list?.length} question papers</p></div>
                                        </div>
                                    </div>
                                    <div className='button-footer mt-2 d-flex'>
                                        <Button type="default" className='view-btn col me-1 rounded'>View</Button>
                                        <Button type="primary" className="col ms-1 rounded">Edit</Button>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </div>
                {/* <Table columns={columns} scroll={{ x: 'calc(230px + 50%)' }} className='table-responsive' dataSource={data} rowKey="id" loading={loading} pagination={paginationConfig} locale={customLocale} /> */}
            </div>
            <ReconfirmDeleteModal openModal={openDelModal} handleBack={handleBack} mid={3} callBackFunc={callBackFunc1} />
            <Modal title="Send Email" open={openModal} confirmLoading={loading13} onOk={() => sendEmailtoAll()} onCancel={handleClose} okText="Send mail">
                <h6>An exam link email will be sent to all applicants associated with this exam. Do you want to continue?</h6>
            </Modal>
            <Modal className="delete-modal" confirmLoading={loading13} open={openDangerModal} onCancel={handleCancel1} onOk={resendEmail} maskClosable={false} okText="Resend mail"
                cancelButtonProps={{
                    style: { backgroundColor: '#5a53b2', color: 'white' }
                }}
            >
                <div className="d-flex justify-content-center">
                    <Image src={DelImg} preview={false} height="90px" />
                </div>
                <h5 className="text-center mt-3 text-dark">Are you sure?</h5>
                <p className="fs-15 text-center">
                    An email has already been sent. Do you wish to send it again? This action will resend the exam link to all applicants associated with this exam.
                </p>
            </Modal>
        </div>
    );
};

export default ExamScreen;
